export default __webpack_public_path__ + "static/media/icon-check-green.d02ec859.svg";